import { company_name } from "@/i18n/variables";

const register = {
	// Section for domain collection card
	collection_card_section: {
		accept_domain_terms_and_conditions: {
			href: "https://www.tuxis.nl/voorwaarden-domeinnaam-registraties/",
			text: "Door de registratie van deze domeinnamen geef ik aan <a>de regels en voorwaarden van de registrars</a> tot mij genomen te hebben en te accepteren.",
		},
		delete_all: "Alles verwijderen",
		discount: "Uw korting",
		edit: "Domeinnamen bewerken",
		empty: {
			description: "Kies je gewenste domeinnaam door een zoekopdracht uit te voeren.",
			title: "Geen domeinnamen geselecteerd",
		},
		error: {
			dns_records_not_saved:
				"De DNS records zijn nog niet opgeslagen. Sla de DNS records op om te kunnen registreren.",
		},
		exc_vat: "Excl. BTW",
		price_trustee: "Prijs gevolmachtigde",
		register: "Domeinnamen registreren",
		title: "Geselecteerde domeinnamen",
		total: "Totaalprijs",
	},

	// Complete section
	complete_section: {
		actions: {
			edit: "Bewerking",
			register: "Registratie",
			transfer: "Verhuizing",
		},
		button_text: "Naar domeinnamen",

		description: "De volgende domeinnamen zijn aangevraagd:",

		description_error:
			"Let op! Er is iets misgegaan bij het aanvragen van registreren/verhuizen. \nHet gaat om de onderstaande domeinen:",
		dns: {
			failed: "DNS toevoegen mislukt",
			success: "DNS succesvol toegevoegd",
		},
		info_alert:
			"Let op! Dit betekent niet dat de door u aangevraagde domeinen al zijn geregistreerd. U ontvangt van ons een mail wanneer de aanvraag definitief is.",
		title: "Domeinregistratie in behandeling",
	},

	// DNS management section
	dns_management: {
		bttn_dns_fetch: "DNS ophalen",
		bttn_dns_select_template: "Template selecteren",
		title: "DNS beheren",
	},

	// Domain holder section
	domain_holder_section: {
		description: "Om een nieuw domein te kunnen registreren, zijn enkele van uw gegevens vereist.",
		local_presence: {
			alert: {
				accept_risk_button: "Ik heb de risico's tot mij genomen en begrijp en aanvaard de risico's",
				description:
					"Voor de volgende TLD's is lokale aanwezigheid vereist. Dit kan omzeild worden door een gevolmachtigde te gebruiken. ",
				risk_button: "Bekijk de risico's",
				risk_description:
					"Door akkoord te gaan met het gebruik van een gevolmachtigde geeft u aan dat u de risico's tot u genomen heeft en deze accepteert.",

				// When any change is made to the text of risk_overview, then this change MUST also be made in the order confirmation email templates in the backend.
				risk_overview: `
### Bij het gebruik van een gevolmachtigde ('proxy') voor de registratie van een domeinnaam zijn er verschillende risico's waar u rekening mee moet houden:

- Lokale aanwezigheidsvereisten zijn er niet voor niets. Het omzeilen van deze regels kan leiden tot juridische problemen, zowel voor u als voor de gevolmachtigde.
- Er kan onduidelijkheid bestaan over wie de werkelijke eigenaar van de domeinnaam is. In sommige gevallen kan de gevolmachtigde technisch gezien als de eigenaar worden beschouwd, wat problemen kan veroorzaken als u de controle over de domeinnaam wilt behouden of wijzigen.
- U bent afhankelijk van de betrouwbaarheid en integriteit van de gevolmachtigde. Als deze persoon of entiteit besluit misbruik te maken van hun positie, kan dit leiden tot verlies van de domeinnaam of andere gerelateerde problemen.
- Uw domeinnaam kan een cruciaal onderdeel zijn van uw online aanwezigheid. Door een derde partij in te schakelen, introduceert u een extra schakel waar beveiligingsproblemen kunnen ontstaan.
- De verlenging en het beheer van de domeinnaam worden gecompliceerder. Communicatie en coördinatie met de gevolmachtigde zijn noodzakelijk, wat kan leiden tot vertragingen, misverstanden en/of fouten waardoor een domeinnaam vrijgegeven kan worden.
- Het vermogen om wijzigingen aan te brengen of problemen op te lossen met betrekking tot de domeinnaam kan beperkt zijn, omdat u afhankelijk bent van de medewerking en beschikbaarheid van de gevolmachtigde.
- Als de gevolmachtigde betrokken raakt bij illegale of onethische activiteiten, kan dit negatieve gevolgen hebben voor uw reputatie, vooral als uw domeinnaam hiermee in verband wordt gebracht.

### Tuxis is op geen enkele wijze aansprakelijk voor directe of indirecte schade of gevolgschade bij de inzet van een gevolmachtigde voor registratie van een domeinnaam.
`,
				risk_overview_title: "Risico's van het gebruik van een gevolmachtigde",
				title: "Gebruik volmacht",
			},
			title: "Gevolmachtigde toevoegen",
		},
		relation: {
			same_as_holder_error:
				"De geselecteerde relatie is de huidige houder van dit domein. Selecteer een andere relatie.",
			title: "Relatie selecteren",
		},
		relation_check: {
			title: "Gegevens ter controle",
		},
		title: "Domeinhouder kiezen",
		tld_requirements: {
			address: {
				description: "Voor de volgende domeinen zijn aanvullende adresgegevens verplicht:",
				title: "Aanvullende adresgegevens vereist!",
			},
			business_only: {
				description:
					"De volgende domeinnamen kunnen alleen geregistreerd worden voor zakelijke relaties. Selecteer een andere relatie of verwijder de domeinnaam.",
				title: "De volgende domeinen kunnen niet geregistreerd worden",
			},
			company: {
				company_private_relation:
					"Doordat u een particuliere relatie hebt geselecteerd, kunt u deze gegevens niet aanvullen. Kies een bedrijfsrelatie of verwijder de volgende domeinen uit de lijst met te registreren domeinen (later registreren):",
				description: "Voor de volgende domeinen zijn aanvullende bedrijfsgegevens verplicht:",
				title: "Aanvullende bedrijfsgegevens vereist!",
			},
			personal_details: {
				description: "Voor de volgende domeinen zijn aanvullende persoonsgegevens verplicht:",
				title: "Aanvullende persoonsgegevens vereist!",
			},
			register_later_bttn: "Later registreren",
			remove_domain_bttn: "Domein verwijderen",
			title:
				"Aanvullende gegevens vereist! Deze worden na registratie toegevoegd aan de geselecteerde relatie.",
			trademark: {
				description: "Voor de volgende domeinen zijn trademark informatie verplicht:",
				title: "Aanvullende trademark informatie vereist!",
			},
		},
	},

	// Error messages
	error_messages: {
		transfer_domain:
			"Er is een fout opgetreden bij het verhuizen van een domein. Als het probleem aanhoudt, neem dan contact op met onze klantenservice.",
		update_relation_domain_details:
			"Er is een fout opgetreden tijdens het verwerken van de gegevens van de relatie. Als het probleem aanhoudt, neem dan contact op met onze klantenservice.",
	},

	// Section for search results
	search_result_section: {
		domain_result_record: {
			available: "Beschikbaar",
			months: "maanden",
			register: "Registreren",
			taken: "Bezet",
			transfer: "Verhuizen",
			unavailable: "Niet Beschikbaar",
			unavailable_price: "Prijs niet beschikbaar",
		},
		title: "Gevonden domeinnamen",
	},

	// Section for searching domains
	search_section: {
		error_fetch_domain_purchase_info:
			"Er is een fout opgetreden bij het ophalen van de informatie van de domeinextensie. Als het probleem aanhoudt, neem dan contact op met onze klantenservice.",
		extension_unavailable: `Deze extensie lijkt niet te bestaan. Wilt u dat ${company_name} contact met u opneemt over de registratie van deze extensie?`,
		extension_unavailable_bttn: "Foutmelding versturen",
		extension_unavailable_bttn_success: "Foutmelding succesvol verstuurd",
		oxxa_unavailable:
			"Let op! Op dit moment is het niet mogelijk om de domeinstatus op te vragen bij de desbetreffende provider. Domein status kan afwijken na registratie.",
		search_alternative_tlds_placeholder: "Bijvoorbeeld '.nl'",
		search_placeholder: `Bijvoorbeeld ${company_name}.nl`,
		sending_extension_unavailable_mail_failed:
			"De foutmelding kon niet worden verstuurd. Probeer het later opnieuw. Als het probleem aanhoudt, neem dan contact op met onze klantenservice.",
		show_alternative_tlds: "Meer extensies",
		title: "Kies je domeinnaam",
	},
	// Titles
	titles: {
		edit: "Domeinnaam bewerken",
		register: "Domeinnaam registreren",
	},

	transfer_token_section: {
		description:
			"De verhuiscode kunt u opvragen bij de partij waar uw domeinnaam momenteel geregistreerd staat.",
		title: "Verhuiscodes invoeren",
		token: "Verhuiscode",
	},
};

export default register;
